import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeIn, fadeOut, slideDown, slideUp } from 'src/app/animations';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';
import { JobStatusTypes } from 'src/app/models/enum/job-status-types.enum';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { ServiceContractJobType } from 'src/app/models/enum/service-contract-job-type.enum';
import { Job } from 'src/app/models/job.model';
import { BitwiseHelper } from 'src/app/services/helpers/bitwise.helper';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';
import { ButtonIcons } from '../action-button/models/button-icons.enum';

@Component({
	selector: 'job-details',
	templateUrl: './job-details.component.html',
	styleUrls: ['./job-details.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss'],
	animations: [slideUp(100), slideDown(100), fadeIn(200), fadeOut(200)]
})
export class JobDetailsComponent implements AfterViewInit {

	public job: Job;
	public customerPreferences: SettingsPreferences;
	public self = this;
	public isLoading = false;
	public isVendor = false;

	public readonly PageType = PageType;
	public readonly ButtonIcons = ButtonIcons;
	public readonly JobStatusTypes = JobStatusTypes;
	public readonly ActionsPlaceholderSettings = ActionsPlaceholderSettings;
	public readonly BitwiseHelper = BitwiseHelper;
	public readonly ServiceContractJobType = ServiceContractJobType;

	public pageType: PageType;

	public get isAssignee(): boolean {
		return BitwiseHelper.and(this.pageType, PageType.Assignee) && !this.isVendor;
	}

	public get isJobRegular(): boolean {
		return this.job.jobTypeId === ServiceContractJobType.Regular;
	}

	public get isJobSupport(): boolean {
		return this.job.jobTypeId === ServiceContractJobType.Support;
	}

	public get isJobDigitalLogbook(): boolean {
		return this.job.jobTypeId === ServiceContractJobType.DigitalLogbook;
	}

	public get isJobSmartDocs(): boolean {
		return this.job.jobTypeId === ServiceContractJobType.SmartDocs;
	}

	public get shouldShowMessageTemplate(): boolean {
		return (this.pageType === PageType.Customer && (this.customerPreferences.preferences.isJobAutoSkipped || this.customerPreferences.preferences.isNotificationDisabled))
			|| ((this.pageType & PageType.AssigneeOrVendor) && this.customerPreferences.preferences.isJobAutoSkipped);
	}

	public get isJobFlowDone(): boolean {
		return [JobStatusTypes.Completed, JobStatusTypes.Canceled].includes(this.job.statusId);
	}

	constructor(
		private route: ActivatedRoute,
		private router: Router
	) {
		this.pageType = this.route.snapshot.data.pageType;
		this.job = (this.route.snapshot.data.jobDetails || {}) as Job;
		this.customerPreferences = this.route.snapshot.data.customerPreferences as SettingsPreferences;
		this.isVendor = this.route.snapshot.data.isVendor;
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public navigateWithData(subpage: string): void {
		this.router.navigate([subpage], { relativeTo: this.route, state: { job: this.job } });
	}
}
